<button class="view-link"
        style="display: inline-flex; vertical-align: middle;"
        matTooltip="Click here to browse the study in the DICOM viewer."
        (click)="handleFileClick($event, element)">
  <mat-icon aria-hidden="false"
            aria-label="preview icon">
    preview
  </mat-icon>
  {{ element.filePath?.indexOf(dicomdirFileName) >= 0 || element.fileName === dicomdirFileName ? 'Imaging Study' : element.fileName }}
</button>
